import { render, staticRenderFns } from "./HalfSunIcon.vue?vue&type=template&id=541d6c53&"
import script from "./HalfSunIcon.vue?vue&type=script&lang=js&"
export * from "./HalfSunIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports